import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { DocumentEditComponent } from '@fi-app/document/edit/edit.component';
import { FiDocumentStatesResolveDefaultDocumentSettings } from '@fi-app/document/states/resolve/default-document-settings';
import { FiDocumentStatesResolveDefaultTemplateSettings } from '@fi-app/document/states/resolve/default-template-settings';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DocumentService } from '@fi-app/document/document.service';
import { FiDocumentStatesResolveDocumentTemplates } from '@fi-app/document/states/resolve/document-templates';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDocumentStatesResolveRecentAIRequests } from '@fi-app/document/states/resolve/recent-ai-requests';

export const FiDocumentRestoreState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Restore,
    url: '/:Id/Restore/:Version?languageId',
    views: {
        '@': {
            component: DocumentEditComponent,
        },
    },
    resolve: {
        document: [DocumentService, FiStateService, Transition, FiDocumentRestoreStateResolveDocumentResolveFunc],
        defaultDocumentSettings: FiDocumentStatesResolveDefaultDocumentSettings,
        defaultTemplateSettings: FiDocumentStatesResolveDefaultTemplateSettings,
        pageTitle: FiDocumentStatesResolvePageTitle,
        documentTemplates: FiDocumentStatesResolveDocumentTemplates,
        recentAIRequests: FiDocumentStatesResolveRecentAIRequests,
    },
};

export function FiDocumentRestoreStateResolveDocumentResolveFunc(
    documentService: DocumentService,
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    const params = fiStateService.getParams($transition$);
    return documentService.GetDocumentByVersion(params.Id, params.Version);
}
